export const EVENTS = {
  CHECKOUT: {
    // Flow
    START: 'checkout.start',
    STEP_CHANGED: 'checkout.step_changed',

    // Order
    CREATE_ORDER: 'checkout.create_order',
    CREATE_ORDER_SUCCESS: 'checkout.create_order_success',
    CREATE_ORDER_ERROR: 'checkout.create_order_error',

    // Payment
    PROCESS_PAYMENT: 'checkout.process_payment',
    PROCESS_PAYMENT_SUCCESS: 'checkout.process_payment_success',
    PROCESS_PAYMENT_ERROR: 'checkout.process_payment_error',

    // Payment Methods
    FETCH_PAYMENT_METHODS: 'checkout.fetch_payment_methods',
    PAYMENT_METHODS_LOADED: 'checkout.payment_methods_loaded',

    // Promo Code
    APPLY_PROMO: 'checkout.apply_promo',
    APPLY_PROMO_SUCCESS: 'checkout.apply_promo_success',
    APPLY_PROMO_ERROR: 'checkout.apply_promo_error',
    REMOVE_PROMO: 'checkout.remove_promo',

    // Validation
    VALIDATE_STEP: 'checkout.validate_step',
    VALIDATION_ERROR: 'checkout.validation_error',
  }
};

export const ENDPOINTS = {
  CHECKOUT: {
    CREATE_ORDER: '/checkout/orders',
    PROCESS_PAYMENT: '/checkout/payment',
    VALIDATE_PROMO: '/checkout/promo/validate',
    PAYMENT_METHODS: '/checkout/payment/methods',
  }
};

export const STEPS = [
  { id: 1, title: 'Review', description: 'Vérifiez votre commande' },
  { id: 2, title: 'Participants', description: 'Informations des participants' },
  { id: 3, title: 'Paiement', description: 'Mode de paiement' },
  { id: 4, title: 'Confirmation', description: 'Commande confirmée' },
];
